module.exports = __webpack_public_path__ + "img/Engagement plan-Stakeholder engagement.386d72b5.svg";